import { setPendingFiles } from "../utils/store";

const MAX_FILES = 6;

export async function renderLanding(
  root: HTMLElement,
  onStart: () => void
): Promise<void> {
  root.innerHTML = `
    <header class="app-header">
      <div class="app-header__inner">
        <h1 class="app-header__title">Merge PDF</h1>
        <p class="app-header__subtitle">Light PDF Tools, Portable &amp; Fully Private</p>
      </div>
    </header>

    <main class="page">
      <section class="info-block">
        <p class="info-block__line" style="font-weight:400">Function: Combine multiple PDFs into one single file, up to 6 documents per task.</p>
        <p class="info-block__line" style="font-weight:400">Limits: Total size of all selected files &#8804; 85MB.</p>
      </section>

      <div class="cta-area">
        <input type="file" accept="application/pdf" multiple data-action="picker" style="display:none" />
        <button class="btn-primary btn-large" data-action="start">Select Files (Minimum 2)</button>
        <p class="cta-hint">PDF format only</p>
      </div>

      <section class="info-block info-block--bottom">
        <p class="info-block__line" style="font-weight:400">Watermark: Clean, no watermarks. Processed files will not include any brand watermarks.</p>
        <p class="info-block__line" style="font-weight:400">Security: All files are deleted immediately after processing</p>
      </section>
    </main>
  `;

  const picker = root.querySelector<HTMLInputElement>('[data-action="picker"]')!;
  const startBtn = root.querySelector<HTMLButtonElement>('[data-action="start"]')!;

  startBtn.addEventListener("click", () => picker.click());

  picker.addEventListener("change", () => {
    const picked = Array.from(picker.files ?? []);
    const valid: File[] = [];
    for (const f of picked) {
      if (valid.length >= MAX_FILES) break;
      if (f.type === "application/pdf") valid.push(f);
    }
    if (valid.length > 0) {
      setPendingFiles(valid);
      onStart();
    }
  });
}
